import {
  TableWrapper,
  TContainer,
  TableHead,
  TableBody,
  Row,
  THeader,
  HeaderTitle,
} from './styles';
import { ObservationRow } from './observationRow';

export interface Observation {
    devId: string
    date: string
    OBS_DESC: string
    userId: string
    observationId: string
}

interface ObservationTableProps {
  data: Observation[];
  t: (key: string) => string;
  onEdit: (item: Observation) => void;
  onDelete: (item: Observation) => void;
}

export function ObservationTable({
  data, t, onEdit, onDelete,
}: Readonly<ObservationTableProps>): JSX.Element {
  return (
    <TableWrapper>
      <TContainer>
        <TableHead>
          <Row>
            <THeader><HeaderTitle><span>{t('descricao')}</span></HeaderTitle></THeader>
            <THeader><HeaderTitle><span>{t('data')}</span></HeaderTitle></THeader>
            <THeader><HeaderTitle><span>{t('usuario')}</span></HeaderTitle></THeader>
            <THeader><HeaderTitle><span>&nbsp;</span></HeaderTitle></THeader>
          </Row>
        </TableHead>

        <TableBody>
          {data.map((item) => (
            <ObservationRow
              key={item.observationId}
              item={item}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </TableBody>
      </TContainer>
    </TableWrapper>
  );
}
